/*eslint-disable */
/* START ALAMBRICO */

// Helper function to safely call cntrUpTag
const safeTrack = (id) => {
    if (typeof window !== 'undefined' && window.cntrUpTag) {
        window.cntrUpTag.track('cntrData', id);
    }
};

export const landingAlambrico = {
    tag : () => {
        safeTrack('94df03c0ff7458f6');
    },
    floodlight : () =>{
        safeTrack('94df03c0ff7458f6');
    },
    image: `<img src="https://pixel.sitescout.com/up/94df03c0ff7458f6?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/94df03c0ff7458f6?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}

export const postpagoAlambrico = {
    tag : () => {
        safeTrack('b14d3caddf7c440b');
    },
    floodlight : () =>{
        safeTrack('b14d3caddf7c440b');
    },
    image: `<img src="https://pixel.sitescout.com/up/b14d3caddf7c440b?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/b14d3caddf7c440b?erp_id=`
}


export const prepagoAlmabrico = {
    tag : () => {
        safeTrack('68b1353efe8fffe0');
    },
    floodlight : () =>{
        safeTrack('68b1353efe8fffe0');
    },
    image: `<img src="https://pixel.sitescout.com/up/68b1353efe8fffe0?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/68b1353efe8fffe0?`
}

export const paqueteAlambrico = {
    tag : () => {
        safeTrack('21ec1e5926d4057a');
    },
    floodlight : () =>{
        safeTrack('21ec1e5926d4057a');
    },
    image: `<img src="https://pixel.sitescout.com/up/21ec1e5926d4057a?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/21ec1e5926d4057a?`
}

export const checkoutStepOneAlambrico = {
    tag : () => {
        safeTrack('881a0d9aec5182b7');
    },
    floodlight : () =>{
        safeTrack('881a0d9aec5182b7');
    },
    image: `<img src="https://pixel.sitescout.com/up/881a0d9aec5182b7?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/881a0d9aec5182b7?`
}

export const checkoutStepTwoAlambrico = {
    tag : () => {
        safeTrack('a11797d5e286c7ed');
    },
    floodlight : () =>{
        safeTrack('a11797d5e286c7ed');
    },
    image: `<img src="https://pixel.sitescout.com/up/a11797d5e286c7ed?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/a11797d5e286c7ed?`
}

/* END ALAMBRICO */

/* START INALAMBRICO */
export const landingInalambrico = {
    tag : () => {
        safeTrack('c93b48fe0e8a76b8');
    },
    floodlight : () =>{
        safeTrack('c93b48fe0e8a76b8');
    },
    image: `<img src="https://pixel.sitescout.com/up/c93b48fe0e8a76b8?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/c93b48fe0e8a76b8?`
}


export const postpagoInalambrico = {
    tag : () => {
        safeTrack('b56014de2ebfb1c3');
    },
    floodlight : () =>{
        safeTrack('b56014de2ebfb1c3');
    },
    image: `<img src="https://pixel.sitescout.com/up/b56014de2ebfb1c3?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/b56014de2ebfb1c3?`
}

export const prepagoInalambrico = {
    tag : () => {
        safeTrack('f7431b0d02979fcc');
    },
    floodlight : () =>{
        safeTrack('f7431b0d02979fcc');
    },
    image: `<img src="https://pixel.sitescout.com/up/f7431b0d02979fcc?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/f7431b0d02979fcc?`
}


export const paqueteInalambrico = {
    tag : () => {
        safeTrack('f17498379618f138');
    },
    floodlight : () =>{
        safeTrack('f17498379618f138');
    },
    image: `<img src="https://pixel.sitescout.com/up/f17498379618f138?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/f17498379618f138?`
}

export const coberturaInalambrico = {
    tag : () => {
        safeTrack('a678615dd674d32e');
    },
    floodlight : () =>{
        safeTrack('a678615dd674d32e');
    },
    image: `<img src="https://pixel.sitescout.com/up/a678615dd674d32e?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/a678615dd674d32e?`
}


export const checkoutStepOneInalambrico = {
    tag : () => {
        safeTrack('00db4cd73b8276e6');
    },
    floodlight : () =>{
        safeTrack('00db4cd73b8276e6');
    },
    image: `<img src="https://pixel.sitescout.com/up/00db4cd73b8276e6?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/00db4cd73b8276e6?`
}

export const checkoutStepTwoInalambrico = {
    tag : () => {
        safeTrack('81b2813aca95bbd9');
    },
    floodlight : () =>{
        safeTrack('81b2813aca95bbd9');
    },
    image: `<img src="https://pixel.sitescout.com/up/81b2813aca95bbd9?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/81b2813aca95bbd9?`
}

export const checkoutStepThreeInalambrico = {
    tag : () => {
        safeTrack('f34167f26228fea2');
    },
    floodlight : () =>{
        safeTrack('f34167f26228fea2');
    },
    image: `<img src="https://pixel.sitescout.com/up/f34167f26228fea2?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/f34167f26228fea2?`
}

export const checkoutStepFourInalambrico = {
    tag : () => {
        safeTrack('d80b50afb442c6af');
    },
    floodlight : () =>{
        safeTrack('d80b50afb442c6af');
    },
    image: `<img src="https://pixel.sitescout.com/up/d80b50afb442c6af?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/d80b50afb442c6af?`
}

export const checkoutStepFiveInalambrico = {
    tag : () => {
        safeTrack('7ce4aae79b63c303');
    },
    floodlight : () =>{
        safeTrack('7ce4aae79b63c303');
    },
    image: `<img src="https://pixel.sitescout.com/up/7ce4aae79b63c303?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/7ce4aae79b63c303?`
}

export const checkoutStepSixInalambrico = {
    tag : () => {
        safeTrack('4416667676e20517');
    },
    floodlight : () =>{
        safeTrack('4416667676e20517');
    },
    image: `<img src="https://pixel.sitescout.com/up/4416667676e20517?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/4416667676e20517?`
}


export const effectivo = {
    tag : () => {
        safeTrack('f7431b0d02979fcc');
    },
    floodlight : () =>{
        safeTrack('f7431b0d02979fcc');
    },
    image: `<img src="https://pixel.sitescout.com/up/f7431b0d02979fcc?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/f7431b0d02979fcc?`
}


export const thankyouPage = {
    tag : () => {
        safeTrack('2f6d019271e2cc35');
    },
    floodlight : () =>{
        safeTrack('2f6d019271e2cc35');
    },
    image: `<img src="https://pixel.sitescout.com/up/2f6d019271e2cc35?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/2f6d019271e2cc35?`
}

/* END INALAMBRICO */